import { SxProps, Theme } from '@mui/material';

export const paginationStyles = {
	wrapper: { display: 'flex', justifyContent: 'center' },
	bar: {
		'& .MuiPaginationItem-root': {
			color: 'rgba(255, 255, 255, 0.6)',
			fontWeight: 500,
			fontSize: '14px',
			lineHeight: '17px',
			fontFamily: 'Integral CF',
		},
		'& .Mui-selected': {
			color: 'white',
			'&.Mui-disabled': {
				color: 'rgba(255, 255, 255, 0.8)',
			},
		},
		'& li:first-of-type, & li:last-of-type': {
			display: 'none',
		},
	},
};
